import { toast } from "react-toastify"
import { addStageSuccess, requestPending } from "./stageSlice"
import stageApi from "../../apis/stageApi"

export const addStageAction = (obj) => async (dispatch) => {
  console.log(obj)
  try {
    dispatch(requestPending())
    const { status, message, stage } = await stageApi.addAStage(obj)

    status === "success"
      ? dispatch(addStageSuccess(stage)) && toast[status](message)
      : dispatch(addStageSuccess()) && toast[status](message)
  } catch (error) {
    return {
      status: "error",
      message: error.message,
    }
  }
}
